<template>
    <div>
        <div class="vx-row">
            <vx-card class="vx-col w-full mb-6">
                <div class="vx-row">
                    <div class="vx-col xl:w-1/3 lg:w-1/2 w-full vs-con-loading__container" id="dataDiv">
                        <h4 class="mb-6">Worker {{worker.name}}</h4>
                        <table class="simple-table">
                            <tr>
                                <td class="font-semibold">Name:</td>
                                <td>{{ worker.name }}</td>
                            </tr>
                            <tr>
                                <td class="font-semibold">Status:</td>
                                <td>
                                    <vs-chip v-if="worker.status === 1" color="success">Online</vs-chip>
                                    <vs-chip v-else color="danger">Offline</vs-chip>
                                </td>
                            </tr>
                            <tr v-if="worker.status === 0">
                                <td class="font-semibold">Last time online:</td>
                                <td>{{ moment(worker.last_ping_time).format('DD/MM/YYYY HH:mm') }}</td>
                            </tr>
                            <tr>
                                <td class="font-semibold">Docker version:</td>
                                <td>{{ worker.docker_version }}</td>
                            </tr>
                            <tr>
                                <td class="font-semibold">CPU:</td>
                                <td>{{ worker.cpu }}</td>
                            </tr>
                            <tr>
                                <td class="font-semibold">RAM:</td>
                                <td>{{ (worker.ram/1000000000).toFixed(2) }} GB</td>
                            </tr>
                            <tr>
                                <td class="font-semibold">Swap:</td>
                                <td>{{ (worker.swap /1000000000).toFixed(2) }} GB</td>
                            </tr>
                            <tr>
                                <td class="font-semibold">IP:</td>
                                <td>{{ worker.ip }}</td>
                            </tr>
                            <tr>
                                <td class="font-semibold">Port:</td>
                                <td>{{ worker.port }}</td>
                            </tr>

                            <tr>
                                <td class="font-semibold">Client Port:</td>
                                <td>{{ worker.client_port }}</td>
                            </tr>

                            <tr>
                                <td class="font-semibold">Client domain:</td>
                                <td>{{ worker.client_domain }}</td>
                            </tr>

                            <tr>
                                <td class="font-semibold">HTTPS Enabled:</td>
                                <td v-if="worker.https_enabled">Yes</td>
                                <td v-else>No</td>
                            </tr>

                            <tr>
                                <td class="font-semibold">Behind proxy:</td>
                                <td v-if="worker.behind_proxy">Yes</td>
                                <td v-else>No</td>
                            </tr>

                            <tr>
                                <td class="font-semibold">Input template:</td>
                                <td>{{ inTemplate.name }}</td>
                            </tr>

                            <tr>
                                <td class="font-semibold">Work template:</td>
                                <td>{{ workTemplate.name }}</td>
                            </tr>

                            <tr>
                                <td class="font-semibold">Output template:</td>
                                <td>{{ outTemplate.name }}</td>
                            </tr>
                        </table>
                        <vs-divider v-if="$store.state.windowWidth < 1200"/>
                    </div>
                    <div class="vx-col xl:w-2/3 lg:w-1/2 w-full">
                        <multicast-node-ports :worker-id="Number($route.params.id)"/>
                    </div>
                </div>

                <vs-divider v-if="worker.gpu.length > 0"/>

                <div class="p-4 w-full vs-con-loading__container" id="gpuDiv" v-if="worker.gpu.length > 0">
                    <h4 class="mb-3" >GPUs</h4>
                    <vs-table :data="worker.gpu" v-if="worker.gpu.length > 0">

                        <template slot="thead">
                            <vs-th>Custom Name</vs-th>
                            <vs-th>Type</vs-th>
                            <vs-th>Name</vs-th>
                            <vs-th v-if="$store.state.windowWidth > 1000">Total memory</vs-th>
                            <vs-th v-if="$store.state.windowWidth > 1300">Driver version</vs-th>
                            <vs-th v-if="$store.state.windowWidth > 1000">UUID</vs-th>
                            <vs-th v-if="$store.state.windowWidth > 1800">vBIOS version</vs-th>
                            <vs-th v-if="$store.state.windowWidth > 1800">Serial number</vs-th>
                            <vs-th></vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                                <vs-td :data="data[indextr].custom_name">
                                    {{ data[indextr].custom_name }}
                                </vs-td>

                                <vs-td :data="data[indextr].type">
                                    {{ (data[indextr].type === 0) ? "Nvidia" : "AMD" }}
                                </vs-td>

                                <vs-td :data="data[indextr].name">
                                    {{ data[indextr].name }}
                                </vs-td>

                                <vs-td v-if="$store.state.windowWidth > 1000" :data="data[indextr].total_memory">
                                    {{ data[indextr].total_memory }} MB
                                </vs-td>

                                <vs-td v-if="$store.state.windowWidth > 1300" :data="data[indextr].driver_version">
                                    {{ data[indextr].driver_version }}
                                </vs-td>

                                <vs-td v-if="$store.state.windowWidth > 1000" :data="data[indextr].uuid">
                                    {{ data[indextr].uuid }}
                                </vs-td>

                                <vs-td v-if="$store.state.windowWidth > 1800" :data="data[indextr].v_bios_version">
                                    {{ data[indextr].v_bios_version }}
                                </vs-td>

                                <vs-td v-if="$store.state.windowWidth > 1800" :data="data[indextr].serial_number">
                                    {{ data[indextr].serial_number }}
                                </vs-td>

                                <vs-td style="width: 165px">
                                    <vs-button style="float: left" :size="($store.state.windowWidth > 1000) ? 'normal' : 'small'" icon-pack="feather" icon="icon-eye" color="success" class="md:mb-0 mr-2 mb-1" @click="openGPU(data[indextr].uuid)"/>
                                    <vs-button style="float: left" :size="($store.state.windowWidth > 1000) ? 'normal' : 'small'" icon-pack="feather" icon="icon-edit" color="primary" class="md:mb-0 mb-1" @click="openGPUNameEdit(data[indextr].uuid, data[indextr].custom_name)"/>
                                </vs-td>

                            </vs-tr>
                        </template>

                    </vs-table>

                    <vs-popup title="Edit GPU name" :active.sync="gpuNameEditPromptOpen">
                        <div id="editGPUNameDiv" class="vs-con-loading__container" >
                            <p>Name</p>
                            <vs-input v-model="gpuNameEdit['name']" class="w-full"></vs-input>

                            <vs-divider/>
                            <vs-button color="success" class="mt-6; mr-1" @click="saveGPUName">Save</vs-button>
                        </div>
                    </vs-popup>
                </div>

                <vs-divider/>

                <vs-button style="float: left" icon-pack="feather" icon="icon-edit" color="warning" class="mt-6; mr-3" @click="$router.push('/worker/' + $route.params.id + '/edit')">Edit</vs-button>
                <vs-button style="float: left" icon-pack="feather" icon="icon-activity" color="primary" class="mt-6; mr-3" @click="$router.push('/worker/' + $route.params.id + '/metrics')">Metrics</vs-button>
                <div style="clear: both"></div>
            </vx-card>

            <div class="p-4 w-full">
                <worker-channels :worker-id="Number($route.params.id)"/>
            </div>

            <div class="p-4 w-full">
                <multicast-proxy-table :worker-id="Number($route.params.id)" :channel-id="0"/>
            </div>

            <div class="p-4 w-full">
                <checkers-table :worker-id="Number($route.params.id)"/>
            </div>

            <div class="p-4 w-full">
                <worker-logs :worker-id="Number($route.params.id)"/>
            </div>

        </div>

    </div>
</template>
<script>

    import WorkerChannels from './WorkerChannels'
    import MulticastProxyTable from '../MulticastProxy/MulticastProxyTable'
    import WorkerLogs from './WorkerLogs'
    import CheckersTable from './CheckersTable'
    import MulticastNodePorts from '../MulticastNode/MulticastNodePorts'

    export default {
        components: {
            CheckersTable,
            WorkerLogs,
            WorkerChannels,
            MulticastProxyTable,
            MulticastNodePorts
        },
        data() {
            return {

                worker: {
                    name: '',
                    status: 0,
                    docker_version: '',
                    cpu: '',
                    ram: 0,
                    swap: 0,
                    ip: '',
                    port: '',
                    client_domain: '',
                    behind_proxy: '',
                    https_enabled: false,
                    last_ping_time: new Date(),
                    in_template: 0,
                    work_template: 0,
                    out_template: 0,
                    gpu: []
                },

                inTemplate: { id: 0, name: '' },
                workTemplate: { id: 0, name: '' },
                outTemplate: { id: 0, name: '' },

                gpuNameEdit: {
                    uuid: '',
                    name: ''
                },

                gpuNameEditPromptOpen: false

            }
        },
        methods: {
            openGPU(uuid) {
                this.$router.push('/gpu/' + uuid)
            },
            openGPUNameEdit(uuid, name) {
                this.gpuNameEdit.uuid = uuid
                this.gpuNameEdit.name = name
                this.gpuNameEditPromptOpen = true
            },
            saveGPUName() {
                this.$vs.loading({
                    container: '#editGPUNameDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const editPromise = this.$http.put('/api/management/v1/gpu/' + this.gpuNameEdit.uuid + '/name', {
                    name: this.gpuNameEdit.name
                })

                editPromise.then(function() {
                    thisIns.gpuNameEditPromptOpen = false
                    thisIns.$nextTick(function() {
                        thisIns.loadData()
                    })
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                editPromise.finally(function() {
                    thisIns.$vs.loading.close('#editGPUNameDiv > .con-vs-loading')
                })
            },
            loadData() {
                this.$vs.loading({
                    container: '#dataDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/worker/' + this.$route.params.id)
                loadPromise.then(function(response) {
                    thisIns.worker = response.data

                    const inTemplatePromise = thisIns.$http.get('/api/management/v1/template/' + thisIns.worker.in_template.id)
                    inTemplatePromise.then(function(response) {
                        thisIns.inTemplate = response.data
                    }).catch(function(error) {
                        thisIns.$printError(error.response.data)
                    })

                    const workTemplatePromise = thisIns.$http.get('/api/management/v1/template/' + thisIns.worker.work_template.id)
                    workTemplatePromise.then(function(response) {
                        thisIns.workTemplate = response.data
                    }).catch(function(error) {
                        thisIns.$printError(error.response.data)
                    })

                    const outTemplatePromise = thisIns.$http.get('/api/management/v1/template/' + thisIns.worker.out_template.id)
                    outTemplatePromise.then(function(response) {
                        thisIns.outTemplate = response.data
                    }).catch(function(error) {
                        thisIns.$printError(error.response.data)
                    })
                })

                loadPromise.catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                loadPromise.finally(function() {
                    thisIns.$vs.loading.close('#dataDiv > .con-vs-loading')
                })
            }
        },
        mounted() {
            this.loadData()
        }

    }

</script>
<style lang="scss">
    #avatar-col {
        width: 10rem;
    }

    .simple-table {
        td {
            vertical-align: top;
            min-width: 170px;
            padding-bottom: .8rem;
            word-break: break-all;

            @media screen and (max-width:370px) {
                display: block;
            }
        }
    }

    @media screen and (min-width:1201px) and (max-width:1211px),
    only screen and (min-width:636px) and (max-width:991px) {
        #account-info-col-1 {
            width: calc(100% - 12rem) !important;
        }

    }

</style>
